export default "__VITE_ASSET__B9zIOi4f__"